import { EnumLiteralsOf } from '../types/helpers'

export const StyleIds = {
  MLA9: 'mla9',
  MLA8: 'mla8',
  MLA7: 'mla7',
  APA6: 'apa',
  APA7: 'apa7',
  CHICAGO: 'chicago',
} as const

export type StyleId = EnumLiteralsOf<typeof StyleIds>

export const POPULAR_STYLES = [
  { id: 'mla9', name: 'MLA9', alias: null, code: null, url: null },
  { id: 'mla8', name: 'MLA8', alias: null, code: null, url: null },
  { id: 'apa', name: 'APA6', alias: null, code: null, url: null },
  { id: 'apa7', name: 'APA7', alias: null, code: null, url: null },
  { id: 'chicago', name: 'Chicago', alias: null, code: null, url: null },
]

export const GatedStyleRuleTypes = {
  SOFT_ACCOUNT_GATE: 'soft-account-gate',
  UPGRADE_GATE: 'upgrade-gate',
} as const

export const APA_ANNOTATED_BIBLIOGRAPHY = 'apa-annotated-bibliography'
